// Generated by purs version 0.13.8
"use strict";
var Control_Alt = require("../Control.Alt/index.js");
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Apply = require("../Control.Apply/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_Rec_Class = require("../Control.Monad.Rec.Class/index.js");
var Control_MonadZero = require("../Control.MonadZero/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_FoldableWithIndex = require("../Data.FoldableWithIndex/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_FunctorWithIndex = require("../Data.FunctorWithIndex/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Semiring = require("../Data.Semiring/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Traversable = require("../Data.Traversable/index.js");
var Extra_Prelude = require("../Extra.Prelude/index.js");
var Random_Gen = require("../Random.Gen/index.js");
var Random_Util = require("../Random.Util/index.js");
var SubsetLT = (function () {
    function SubsetLT() {

    };
    SubsetLT.value = new SubsetLT();
    return SubsetLT;
})();
var SubsetGT = (function () {
    function SubsetGT() {

    };
    SubsetGT.value = new SubsetGT();
    return SubsetGT;
})();
var Equal = (function () {
    function Equal() {

    };
    Equal.value = new Equal();
    return Equal;
})();
var Partial = (function () {
    function Partial(value0) {
        this.value0 = value0;
    };
    Partial.create = function (value0) {
        return new Partial(value0);
    };
    return Partial;
})();
var Disjoint = (function () {
    function Disjoint() {

    };
    Disjoint.value = new Disjoint();
    return Disjoint;
})();
var unsafeIndex = function (a) {
    return function (i) {
        return a[i];
    };
};
var unproduct = function (v) {
    return {
        h: {
            start: v.x,
            len: v.width
        },
        v: {
            start: v.y,
            len: v.height
        }
    };
};
var tooBig = function (m) {
    return function (v) {
        return v.width > m || v.height > m;
    };
};
var partition = function (min) {
    return function (n) {
        var splitinto3 = (function () {
            var s = n - 2 | 0;
            var max1 = s - (2 * min | 0) | 0;
            return Control_Bind.bind(Random_Gen.bindRandom)(Random_Gen.intRange(min)(max1))(function (split1) {
                var max2 = (s - split1 | 0) - min | 0;
                return Control_Bind.bind(Random_Gen.bindRandom)(Random_Gen.intRange(min)(max2))(function (split2) {
                    var remainder = (s - split1 | 0) - split2 | 0;
                    return Random_Util.shuffle([ split1, split2, remainder ]);
                });
            });
        })();
        var splitinto2 = (function () {
            var s = n - 1 | 0;
            var max = (n - min | 0) - 1 | 0;
            return Control_Bind.bind(Random_Gen.bindRandom)(Random_Gen.intRange(min)(max))(function (split) {
                var remainder = (n - split | 0) - 1 | 0;
                return Control_Applicative.pure(Random_Gen.applicativeRandom)([ split, remainder ]);
            });
        })();
        var result = (function () {
            var v = n >= ((3 * min | 0) + 2 | 0);
            var v1 = n >= ((2 * min | 0) + 1 | 0);
            if (!v1) {
                return Control_Applicative.pure(Random_Gen.applicativeRandom)([ n ]);
            };
            if (v1 && !v) {
                return splitinto2;
            };
            if (v1 && v) {
                return Control_Bind.bind(Random_Gen.bindRandom)(Random_Gen.chance(80))(function (v2) {
                    if (v2) {
                        return splitinto2;
                    };
                    if (!v2) {
                        return splitinto3;
                    };
                    throw new Error("Failed pattern match at Mapgen (line 69, column 37 - line 71, column 29): " + [ v2.constructor.name ]);
                });
            };
            throw new Error("Failed pattern match at Mapgen (line 66, column 16 - line 71, column 29): " + [ v1.constructor.name, v.constructor.name ]);
        })();
        return result;
    };
};
var subdivideInterval = function (minSize) {
    return function (v) {
        return Control_Bind.bind(Random_Gen.bindRandom)(partition(minSize)(v.len))(function (lens) {
            var starts = Data_Array.cons(v.start)(Data_FunctorWithIndex.mapWithIndex(Data_FunctorWithIndex.functorWithIndexArray)(function (i) {
                return function (x) {
                    return (x + i | 0) + 1 | 0;
                };
            })(Data_Traversable.scanl(Data_Traversable.traversableArray)(Data_Semiring.add(Data_Semiring.semiringInt))(v.start)(Extra_Prelude.unsafeFromJust(Data_Array.init(lens)))));
            return Control_Applicative.pure(Random_Gen.applicativeRandom)(Data_Array.zipWith(function (s) {
                return function (l) {
                    return {
                        start: s,
                        len: l
                    };
                };
            })(starts)(lens));
        });
    };
};
var subdivide = function (minSize) {
    return function (v) {
        return Control_Bind.bind(Random_Gen.bindRandom)(subdivideInterval(minSize)({
            start: v.x,
            len: v.width
        }))(function (xIntervals) {
            return Control_Bind.bind(Random_Gen.bindRandom)(subdivideInterval(minSize)({
                start: v.y,
                len: v.height
            }))(function (yIntervals) {
                var mkBlock = function (xi) {
                    return function (yi) {
                        return {
                            x: xi.start,
                            y: yi.start,
                            width: xi.len,
                            height: yi.len
                        };
                    };
                };
                return Control_Applicative.pure(Random_Gen.applicativeRandom)(Control_Apply.apply(Control_Apply.applyArray)(Data_Functor.map(Data_Functor.functorArray)(mkBlock)(xIntervals))(yIntervals));
            });
        });
    };
};
var recursivelySubdivide = function (minSize) {
    return function (maxSize) {
        return function (block) {
            var go = function (v) {
                var v1 = Data_Array.partition(tooBig(maxSize))(v.incomplete);
                var completeNew = Data_Semigroup.append(Data_Semigroup.semigroupArray)(v.complete)(v1.no);
                var $49 = Data_Array["null"](v1.yes);
                if ($49) {
                    return Control_Applicative.pure(Random_Gen.applicativeRandom)(new Control_Monad_Rec_Class.Done(completeNew));
                };
                return Control_Bind.bind(Random_Gen.bindRandom)(Data_Traversable["for"](Random_Gen.applicativeRandom)(Data_Traversable.traversableArray)(v1.yes)(subdivide(minSize)))(function (arrayOfArrays) {
                    var incompleteNew = Data_Array.concat(arrayOfArrays);
                    return Control_Applicative.pure(Random_Gen.applicativeRandom)(new Control_Monad_Rec_Class.Loop({
                        complete: completeNew,
                        incomplete: incompleteNew
                    }));
                });
            };
            return Control_Monad_Rec_Class.tailRecM(Random_Gen.monadRecRandom)(go)({
                incomplete: [ block ],
                complete: [  ]
            });
        };
    };
};
var mapEdgeAdjacenciesForBlock = function (b) {
    var v = b.x === 1 || (b.x + b.width | 0) === 19;
    if (v) {
        var ys = Data_Array.range(b.y)((b.y + b.height | 0) - 1 | 0);
        var x = (function () {
            var $55 = b.x === 1;
            if ($55) {
                return 0;
            };
            return 19;
        })();
        return Data_Functor.mapFlipped(Data_Functor.functorArray)(ys)(function (y) {
            return {
                x: x,
                y: y
            };
        });
    };
    if (!v) {
        var y = (function () {
            var $56 = b.y === 1;
            if ($56) {
                return 0;
            };
            return 19;
        })();
        var xs = Data_Array.range(b.x)((b.x + b.width | 0) - 1 | 0);
        return Data_Functor.mapFlipped(Data_Functor.functorArray)(xs)(function (x) {
            return {
                x: x,
                y: y
            };
        });
    };
    throw new Error("Failed pattern match at Mapgen (line 288, column 3 - line 295, column 34): " + [ v.constructor.name ]);
};
var lookup = function (i) {
    return function (v) {
        return unsafeIndex(v.points)(i);
    };
};
var listAdjacent = function (v) {
    return function (v1) {
        var ls = Extra_Prelude.unsafeFromJust(Data_Map_Internal.lookup(Data_Ord.ordInt)(v1.label)(v.edges));
        var bs = Data_Functor.mapFlipped(Data_Functor.functorArray)(ls)(function (l) {
            return unsafeIndex(v.points)(l);
        });
        return Data_Array.zipWith(function (l) {
            return function (b) {
                return {
                    label: l,
                    value: b
                };
            };
        })(ls)(bs);
    };
};
var getEdges = function (v) {
    return Data_FoldableWithIndex.foldlWithIndex(Data_Map_Internal.foldableWithIndexMap)(function (a) {
        return function (arr) {
            return function (targets) {
                return Data_Semigroup.append(Data_Semigroup.semigroupArray)(arr)(Control_Bind.bind(Control_Bind.bindArray)(targets)(function (b) {
                    return Control_Bind.discard(Control_Bind.discardUnit)(Control_Bind.bindArray)(Control_MonadZero.guard(Control_MonadZero.monadZeroArray)(a < b))(function () {
                        return Control_Applicative.pure(Control_Applicative.applicativeArray)({
                            a: a,
                            b: b
                        });
                    });
                }));
            };
        };
    })([  ])(v.edges);
};
var expandInterval = function (v) {
    return Data_Array.range(v.start)((v.len + v.start | 0) - 1 | 0);
};
var eqOverlap = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof SubsetLT && y instanceof SubsetLT) {
            return true;
        };
        if (x instanceof SubsetGT && y instanceof SubsetGT) {
            return true;
        };
        if (x instanceof Equal && y instanceof Equal) {
            return true;
        };
        if (x instanceof Partial && y instanceof Partial) {
            return x.value0 === y.value0;
        };
        if (x instanceof Disjoint && y instanceof Disjoint) {
            return true;
        };
        return false;
    };
});
var end = function (v) {
    return (v.start + v.len | 0) - 1 | 0;
};
var inInterval = function (x) {
    return function (i) {
        return x >= i.start && x <= end(i);
    };
};
var overlap = function (a) {
    return function (b) {
        var m = function (x) {
            return function (bool) {
                if (bool) {
                    return new Data_Maybe.Just(x);
                };
                return Data_Maybe.Nothing.value;
            };
        };
        var partial = m(Partial.create(1 + Data_Ord.min(Data_Ord.ordInt)(end(a) - b.start | 0)(end(b) - a.start | 0) | 0))(a.start <= end(b) && b.start <= end(a));
        var subsetGT = m(SubsetGT.value)(a.start <= b.start && end(a) >= end(b));
        var subsetLT = m(SubsetLT.value)(a.start >= b.start && end(a) <= end(b));
        var equal = m(Equal.value)(Data_Eq.eq(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
            return "start";
        }))(Data_Eq.eqInt))()(new Data_Symbol.IsSymbol(function () {
            return "len";
        }))(Data_Eq.eqInt)))(a)(b));
        return Data_Maybe.fromMaybe(Disjoint.value)(Control_Alt.alt(Data_Maybe.altMaybe)(Control_Alt.alt(Data_Maybe.altMaybe)(Control_Alt.alt(Data_Maybe.altMaybe)(equal)(subsetLT))(subsetGT))(partial));
    };
};
var disjoint = function (a) {
    return function (b) {
        return Data_Eq.eq(eqOverlap)(overlap(a)(b))(Disjoint.value);
    };
};
var blockOnEdge = function (b) {
    return b.x === 1 || ((b.x + b.width | 0) === 18 || (b.y === 1 || (b.y + b.height | 0) === 18));
};
var mapEdgeAdjacencies = function (blocks) {
    return Data_Array.concat(Data_Functor.map(Data_Functor.functorArray)(mapEdgeAdjacenciesForBlock)(Data_Array.filter(blockOnEdge)(blocks)));
};
var genExit = function (rooms) {
    return Control_Bind.bind(Random_Gen.bindRandom)(Random_Gen.unsafeElement("genExit")(mapEdgeAdjacencies(rooms)))(function (pos) {
        return Control_Applicative.pure(Random_Gen.applicativeRandom)(pos);
    });
};
var areKissing = function (a) {
    return function (b) {
        return a.start === (end(b) + 2 | 0) || b.start === (end(a) + 2 | 0);
    };
};
var blockAdjacencies = function (a) {
    return function (b) {
        var sb = unproduct(b);
        var sa = unproduct(a);
        var v = areKissing(sa.h)(sb.h);
        if (v) {
            var ys = Data_Array.intersect(Data_Eq.eqInt)(expandInterval(sa.v))(expandInterval(sb.v));
            var x = Data_Ord.max(Data_Ord.ordInt)(a.x)(b.x) - 1 | 0;
            return Data_Functor.mapFlipped(Data_Functor.functorArray)(ys)(function (y) {
                return {
                    x: x,
                    y: y
                };
            });
        };
        if (!v) {
            var y = Data_Ord.max(Data_Ord.ordInt)(a.y)(b.y) - 1 | 0;
            var xs = Data_Array.intersect(Data_Eq.eqInt)(expandInterval(sa.h))(expandInterval(sb.h));
            return Data_Functor.mapFlipped(Data_Functor.functorArray)(xs)(function (x) {
                return {
                    x: x,
                    y: y
                };
            });
        };
        throw new Error("Failed pattern match at Mapgen (line 273, column 24 - line 281, column 28): " + [ v.constructor.name ]);
    };
};
var roomAdjacencies = blockAdjacencies;
var genDoors = function (rooms) {
    return Data_Traversable["for"](Random_Gen.applicativeRandom)(Data_Traversable.traversableArray)(getEdges(rooms))(function (v) {
        return Control_Bind.bind(Random_Gen.bindRandom)(Random_Gen.unsafeElement("genDoors")(roomAdjacencies(lookup(v.a)(rooms))(lookup(v.b)(rooms))))(function (pos) {
            return Control_Applicative.pure(Random_Gen.applicativeRandom)({
                pos: pos,
                connectedRooms: [ v.a, v.b ]
            });
        });
    });
};
var blocksAreAdjacent = function (a) {
    return function (b) {
        var sb = unproduct(b);
        var sa = unproduct(a);
        return areKissing(sa.h)(sb.h) && !disjoint(sa.v)(sb.v) || areKissing(sa.v)(sb.v) && !disjoint(sa.h)(sb.h);
    };
};
var roomsAreAdjacent = blocksAreAdjacent;
var adjacent = function (m) {
    return function (x) {
        return function (y) {
            return Data_Maybe.isJust(Data_Foldable.find(Data_Foldable.foldableArray)(function (v) {
                return v.label === y.label;
            })(listAdjacent(m)(x)));
        };
    };
};
var adjacencyMap = function (points) {
    return function (adj) {
        var pairs = (function () {
            var n = Data_Array.length(points) - 1 | 0;
            return Control_Bind.bind(Control_Bind.bindArray)(Data_Array.range(0)(n))(function (a) {
                return Control_Bind.bind(Control_Bind.bindArray)(Data_Array.range(0)(n))(function (b) {
                    return Control_Bind.discard(Control_Bind.discardUnit)(Control_Bind.bindArray)(Control_MonadZero.guard(Control_MonadZero.monadZeroArray)(a !== b))(function () {
                        return Control_Bind.discard(Control_Bind.discardUnit)(Control_Bind.bindArray)(Control_MonadZero.guard(Control_MonadZero.monadZeroArray)(adj(unsafeIndex(points)(a))(unsafeIndex(points)(b))))(function () {
                            return Control_Applicative.pure(Control_Applicative.applicativeArray)({
                                a: a,
                                b: b
                            });
                        });
                    });
                });
            });
        })();
        var edges = Data_Foldable.foldl(Data_Foldable.foldableArray)(function (m) {
            return function (v) {
                return Data_Map_Internal.insertWith(Data_Ord.ordInt)(Data_Semigroup.append(Data_Semigroup.semigroupArray))(v.a)([ v.b ])(m);
            };
        })(Data_Map_Internal.empty)(pairs);
        return {
            points: points,
            edges: edges
        };
    };
};
var generateMapFull = function (c) {
    var startingBlock = {
        x: 1,
        y: 1,
        width: c.width - 2 | 0,
        height: c.height - 2 | 0
    };
    return Control_Bind.bind(Random_Gen.bindRandom)(recursivelySubdivide(c.minBlock)(c.maxBlock)(startingBlock))(function (rooms) {
        var roomAdjacency = adjacencyMap(rooms)(roomsAreAdjacent);
        return Control_Bind.bind(Random_Gen.bindRandom)(genDoors(roomAdjacency))(function (doors) {
            return Control_Bind.bind(Random_Gen.bindRandom)(Data_Traversable.sequence(Data_Traversable.traversableArray)(Random_Gen.applicativeRandom)(Data_Array.replicate(3)(genExit(rooms))))(function (exitCandidates) {
                return Control_Applicative.pure(Random_Gen.applicativeRandom)({
                    rooms: rooms,
                    entrance: {
                        x: 1,
                        y: 2
                    },
                    exitCandidates: exitCandidates,
                    doors: doors
                });
            });
        });
    });
};
module.exports = {
    expandInterval: expandInterval,
    partition: partition,
    subdivideInterval: subdivideInterval,
    subdivide: subdivide,
    tooBig: tooBig,
    recursivelySubdivide: recursivelySubdivide,
    unproduct: unproduct,
    end: end,
    inInterval: inInterval,
    areKissing: areKissing,
    blocksAreAdjacent: blocksAreAdjacent,
    roomsAreAdjacent: roomsAreAdjacent,
    SubsetLT: SubsetLT,
    SubsetGT: SubsetGT,
    Equal: Equal,
    Partial: Partial,
    Disjoint: Disjoint,
    overlap: overlap,
    disjoint: disjoint,
    unsafeIndex: unsafeIndex,
    lookup: lookup,
    adjacencyMap: adjacencyMap,
    getEdges: getEdges,
    listAdjacent: listAdjacent,
    adjacent: adjacent,
    generateMapFull: generateMapFull,
    genExit: genExit,
    genDoors: genDoors,
    blockAdjacencies: blockAdjacencies,
    mapEdgeAdjacenciesForBlock: mapEdgeAdjacenciesForBlock,
    mapEdgeAdjacencies: mapEdgeAdjacencies,
    blockOnEdge: blockOnEdge,
    roomAdjacencies: roomAdjacencies,
    eqOverlap: eqOverlap
};
